import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faEye, faEyeSlash, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { actionChangePasswordRecovery, verifyPasswordRecoveryCode } from "../actions/userActions";
import LoaderComponent from "../components/LoaderComponent";
import { StyledInput, ModernButton } from "../components/DefaultImports";
const Title = styled.h3`
  margin: 20px 0;
  font-weight: bold;
  text-transform: uppercase;
  color: var(--app-orange, #ee754c);
`;
const StyledCard = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 15px;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 576px) {
    padding: 10px;
  }
`;
const PasswordContainer = styled.div`
  position: relative;
`;
const StyledPasswordInput = styled(StyledInput)`
  padding-right: 40px;
`;
const PasswordToggleIcon = styled.div`
  position: absolute;
  top: 40%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 18px;
    color: #ee754c;
  }
`;
function PasswordRecoveryChange({
  code
}) {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [disableButton, setdisableButton] = useState(true);
  const [showPasswords, setShowPasswords] = useState(true);
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [activateLoader, setActivateLoader] = useState(false);
  const userUpdate = useSelector(state => state.userUpdate);
  const {
    verifyPasswordRecovery,
    loadingVerifyPasswordRecovery,
    passwordVerifyRecoveryError,
    changePasswordRecovery,
    loadingChangePasswordRecovery,
    passwordChangeRecoveryError
  } = userUpdate;
  useEffect(() => {
    dispatch(verifyPasswordRecoveryCode(code));
  }, [code]);
  const handleSubmit = e => {
    e.preventDefault();
    dispatch(actionChangePasswordRecovery(code, password));
  };
  useEffect(() => {
    if (password !== confirmPassword || password == "") {
      setPasswordsMatch(false);
      setdisableButton(true);
    } else {
      setPasswordsMatch(true);
      setdisableButton(false);
    }
  }, [password, confirmPassword]);
  const handlePasswordChange = event => {
    setPassword(event.target.value);
  };
  const handleConfirmPasswordChange = event => {
    setConfirmPassword(event.target.value);
  };
  useEffect(() => {
    if (loadingVerifyPasswordRecovery || loadingChangePasswordRecovery) {
      setActivateLoader(true);
    } else {
      setActivateLoader(false);
    }
  }, [loadingVerifyPasswordRecovery, loadingChangePasswordRecovery]);
  useEffect(() => {
    if (changePasswordRecovery && changePasswordRecovery.includes("password_changed")) {
      setPasswordChanged(true);
    } else {
      setPasswordChanged(false);
    }
  }, [changePasswordRecovery]);
  return <Container fluid style={{
    padding: 0,
    margin: 0,
    width: "120%",
    maxWidth: "120%"
  }}>
      <Row className="justify-content-md-center">
        <Col md={6}>
          <StyledCard border="light" className="rounded-lg p-3">
            {verifyPasswordRecovery && verifyPasswordRecovery.includes("still_valid") && !passwordChanged ? <Form onSubmit={handleSubmit}>
                <Title>{t("ui.screens.passwordRecoveryChange.alterarPalavraPasse")}</Title>
                <Form.Label>{t("ui.screens.passwordRecoveryChange.definirNovaPalavraPasse")}</Form.Label>
                <Form.Group controlId="formBasicPassword">
                  <PasswordContainer>
                    <StyledPasswordInput required type={showPasswords ? "password" : "text"} placeholder={t("ui.screens.passwordRecoveryChange.criarNovaPalavraPasse")} value={password} onChange={e => setPassword(e.target.value)} />
                    <PasswordToggleIcon onClick={() => setShowPasswords(!showPasswords)}>
                      <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
                    </PasswordToggleIcon>
                  </PasswordContainer>
                </Form.Group>

                <Form.Group controlId="formBasicConfirmPassword">
                  <PasswordContainer>
                    <StyledPasswordInput required type={showPasswords ? "password" : "text"} placeholder={t("ui.screens.passwordRecoveryChange.confirmarAPalavraPasse")} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                    <PasswordToggleIcon onClick={() => setShowPasswords(!showPasswords)}>
                      <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
                    </PasswordToggleIcon>
                  </PasswordContainer>
                  {!passwordsMatch && <Form.Text className="text-danger">{t("ui.screens.passwordRecoveryChange.asPalavrasPasseNaoCoincidem")}</Form.Text>}
                </Form.Group>
                <ModernButton type="submit" disabled={disableButton} color="#de8c3a" fontSize="16px" style={{
              width: "100%",
              marginTop: "20px"
            }}>{t("ui.screens.passwordRecoveryChange.alterar")}</ModernButton>
              </Form> : !passwordChanged ? <div>{t("ui.screens.passwordRecoveryChange.oLinkEstaExpirado")}</div> : <></>}
            {passwordChanged && <div>
                <FontAwesomeIcon size="lg" icon={faCircleCheck} style={{
              color: "#3dc2a7",
              marginRight: "10px"
            }} />{t("ui.screens.passwordRecoveryChange.aSuaPasswordFoiAlteradaCom")}<p>{t("ui.screens.passwordRecoveryChange.cliqueNoSeguinteBotaoParaEntrar")}</p>
                <Link to={`/login/${"null"}/${"null"}`} style={{
              textDecoration: "none"
            }}>
                  <Button className="mt-3" variant="primary">{t("ui.screens.passwordRecoveryChange.entrarNaConta")}</Button>
                </Link>
              </div>}
          </StyledCard>
        </Col>
      </Row>

      <LoaderComponent activate={activateLoader} theSize={"o"} />
    </Container>;
}
export default PasswordRecoveryChange;
